import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cadastro-layout',
    templateUrl: './cadastro-layout.component.html',
    styleUrls: ['./cadastro-layout.component.scss'],
    standalone: false
})
export class CadastroLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
